import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="empBrokerage";

export function selectByAccountId(parameter){
  console.log("accountId:",parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get'
  })
}

export function selectAllPage(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export default {
  selectByAccountId,
  selectAllPage,
}